import React from 'react'
import { BREAKPOINTS, STATUS } from '@features/General'
import useWindowSize from 'hooks/processor/useWindowSize'
import EventDetailsFooterDesktop from './Desktop'
import EventDetailsFooterMobile from './Mobile'
import { rootActions } from '@app-store/slices'
import { useDispatch, useSelector } from 'react-redux'
import findIndex from 'lodash/findIndex'
import { useHistory } from 'react-router'
import routes from '@utils/constants/routes'
import { RootState } from '@app-store/store'

function EventDetailsFooter() {
    const { width } = useWindowSize()
    const dispatch = useDispatch()
    const history = useHistory()
    const validRoutesKeys = ['details', 'branding', 'import', 'category', 'email-campaign', 'successful']
    const key = routes.organizer.events._
    const active = location.pathname.replace(`${key}/`, '')
    const activeIndex = findIndex(validRoutesKeys, i => i === active)
    const showSkip = ['email-campaign', 'import'].some(item => location.pathname.includes(item))
    const { status, categories } = useSelector((state: RootState) => state.companies.onboarding)
    const { data: i18n } = useSelector((state: RootState) => state.localization.locals)
    const isFetching = status === STATUS.RUNNING
    const onNextClick = () => {
        switch (true) {
            case active === 'details':
                // dispatch(
                //     rootActions.companies.onboarding.onRequestDetails({
                //         nextURL: `${key}/${validRoutesKeys[activeIndex + 1]}`
                //     })
                // )
                break
            case active === 'branding':
                // dispatch(
                //     rootActions.companies.onboarding.onRequestBrand({
                //         nextURL: `${key}/${validRoutesKeys[activeIndex + 1]}`
                //     })
                // )
                break
            case active === 'category':
                dispatch(
                    rootActions.companies.onboarding.onRequestCategory({
                        categories,
                        sagaCB: {
                            onSuccess: () => {
                                // dispatch(rootActions.organizer.eventDetails.view.setFinishModal(true))
                                // history.push(routes.organizer.events._)
                                dispatch(
                                    rootActions.companies.onboarding.onRequestDetails({
                                        nextURL: `${routes.organizer.events._}/successful`
                                    })
                                )
                            }
                        }
                    })
                )
                break
            case active === 'successful':
                history.push(routes.organizer.events._)
                break
            case validRoutesKeys.length - 1 === activeIndex:
                dispatch(rootActions.organizer.eventDetails.view.setFinishModal(true))
                break
            case validRoutesKeys.length - 1 > activeIndex:
                history.push(`${key}/${validRoutesKeys[activeIndex + 1]}`)
                break
            default:
                history.push(`${key}/${validRoutesKeys[activeIndex + 1]}`)
        }
    }

    const onBackClick = () => {
        if (0 < activeIndex) {
            history.push(`${key}/${validRoutesKeys[activeIndex - 1]}`)
        }
    }

    const onLeaveClick = () => {
        dispatch(rootActions.organizer.eventDetails.view.setLeavingModal(true))
    }

    const stepKey = validRoutesKeys[activeIndex]

    if (width < BREAKPOINTS.LG) {
        return (
            <EventDetailsFooterMobile
                hasSkip={showSkip}
                onBack={onBackClick}
                onLeave={onLeaveClick}
                onNext={onNextClick}
                onSkip={onNextClick}
                loading={isFetching}
                i18n={i18n}
                isFinalStep={active === 'successful'}
                stepKey={stepKey}
            />
        )
    }

    return (
        <EventDetailsFooterDesktop
            hasSkip={showSkip}
            activeStep={activeIndex}
            onBack={onBackClick}
            onLeave={onLeaveClick}
            onNext={onNextClick}
            onSkip={onNextClick}
            loading={isFetching}
            i18n={i18n}
            stepKey={stepKey}
        />
    )
}

export default EventDetailsFooter
